import { AUTH, LOGOUT, UPDATE_USER } from '../actions/constants'

const getStoredProfile = () => {
    if (typeof window === 'undefined') return null
    try {
        const raw = localStorage.getItem('profile')
        return raw ? JSON.parse(raw) : null
    } catch (e) {
        console.error('Failed to parse stored profile', e)
        return null
    }
}

const initialState = { authData: getStoredProfile() }

const authReducer =(state = initialState, action)=> {
    switch (action.type) {
        case AUTH:
            localStorage.setItem('profile', JSON.stringify({ result: action?.data?.result, userProfile: action?.data?.userProfile }))
            return {...state, authData: { result: action?.data?.result, userProfile: action?.data?.userProfile }}

            case LOGOUT:
                localStorage.removeItem('profile')
                return {...state, authData: null}

            case UPDATE_USER:
                localStorage.setItem('profile', JSON.stringify({ result: action?.data?.result, userProfile: action?.data?.userProfile }))
                return {...state, authData: { result: action?.data?.result, userProfile: action?.data?.userProfile }}
        
        default:
            return state
    }
}

export default authReducer
